import {
    SnotifyPosition,
    SnotifyStyle
} from 'vue-snotify'

const state = {
    type: null,
    notifyType: null,
    message: null,
    time: 0,
    data: {}
};

const actions = {
    default ({
        commit
    }, message) {        
        commit('default', message);
    },
    success({
        commit
    }, message) {
        commit('success', message);
    },
    error({
        commit
    }, message) {
        commit('error', message);
    },
    clear({
        commit
    }, message) {
        commit('success', message);
    }
};

const mutations = {
    default (state, message) {
        state.time = new Date();
        state.type = 'alert-default';
        state.notifyType = SnotifyStyle.info;
        state.message = message;
        state.data = {};       
    },
    success(state, message) {
       // console.log("mensaje->" + message)
        state.time = new Date();
        state.notifyType = SnotifyStyle.success;
        state.type = 'alert-success';
        state.message = message;
        state.data = {};
    },
    error(state, message) {

        state.time = new Date();
        state.notifyType = SnotifyStyle.error;
        state.type = 'alert-danger';
       
        if ((typeof message) == "string") {
            state.message = message;  
            return;          
        }

        if (message.data && message.data.hasOwnProperty('data')) {
            state.message = message.data.message;
            state.data = message.data;
        } else {
            state.data = {};
            state.message = message.message;
        }

    },
    clear(state) {
        state.type = null;
        state.message = null;
    },
    question(state, message) {
        
    }
};

export const notifier = {
    namespaced: true,
    state,
    actions,
    mutations
};